import { render } from "./PublicAlertComponent.vue?vue&type=template&id=0d1ba50c&scoped=true"
import script from "./PublicAlertComponent.vue?vue&type=script&lang=js"
export * from "./PublicAlertComponent.vue?vue&type=script&lang=js"

import "./PublicAlertComponent.vue?vue&type=style&index=0&id=0d1ba50c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src330103864/src/flip-child-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1ba50c"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QSpace,QBtn,QSeparator,QIcon,QCardActions});qInstall(script, 'directives', {ClosePopup});
